import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"



export const chartsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAdminGradesByTask: builder.mutation({
            query: initialMessage => ({
                url: '/api/charts/tasks',
                method: 'POST',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: [
                
            ]
        }),
        getAdminGradesByQuestion: builder.mutation({
            query: initialMessage => ({
                url: '/api/charts/questions',
                method: 'POST',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: [
                
            ]
        }),
        getStudentGrades: builder.query({
            query: () => ({
                url: '/api/charts/student-grades',
                method: 'GET',
           
            }),
            invalidatesTags: [
                
            ]
        }),
       
    }),
   
})

export const {
   useGetAdminGradesByTaskMutation,
    useGetAdminGradesByQuestionMutation,
    useGetStudentGradesQuery,
   
} =chartsApiSlice

